module.exports = __webpack_public_path__ + "staticcomp/img/top.109f830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/15/top.jpg
// module id = LPdS
// module chunks = 39